
import styled, { keyframes } from 'styled-components'

import COLORS from 'constants/colors'
import FONTS from 'constants/fonts'
import MEDIA from 'constants/media'


import { Props } from './types'

export const Container = styled.label`
  display: flex;
  vertical-align: middle;
  width: 100%;
  justify-content: center;
`

const checkboxKeyframes = keyframes`
  0% {
    width: 0;
    height: 0;
  }
  100% {
    width: 10px;
    height: 18px;
    transform: rotate(45deg);
    transform-origin: 0% 100%;
  }
`

export const HiddenCheckbox = styled.input.attrs(() => ({ type: 'checkbox' }))`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

export const VisibleCheckbox = styled.span.attrs<Props>(
  ({ isChecked }) => ({ className: isChecked ? 'isChecked' : '' }),
)<Props>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 30px;
  height: 30px;
  background: transparent;
  border: 4px solid ${COLORS.BLACK};
  border-radius: 2px;
  cursor: pointer;
  transition: all 250ms cubic-bezier(0.4, 0, 0.23, 1);
  &.isChecked {
    border: 4px solid ${COLORS.GREYMEDIUM};

    &:before {
      content: '';
      position: relative;
      top: -8px;
      left: -5px;
      border-right: 3px solid ${COLORS.BLACK};
      border-bottom: 3px solid ${COLORS.BLACK};
      animation: ${checkboxKeyframes} 0.25s cubic-bezier(0.4, 0, 0.23, 1) forwards;
    }
  }
`

export const LabelContent = styled.span`
  color: ${COLORS.BLACK};
  display: block;
  padding-left: 10px;
  font-family: ${FONTS.FAMILYSECONDARY};
  font-weight: ${FONTS.WEIGHTDEMI};
  text-align: center;
  font-size: ${FONTS.FONTLABELMOBILE};
  cursor: pointer;
  ${MEDIA.medium`
    font-size: ${FONTS.FONTLABEL};
  `}
`
